module.exports = __webpack_public_path__ + "h5-static/img/loading_320x320.9cce1919.gif";